import { Link } from "react-router-dom";
import Slide from "react-reveal/Slide";

export const ClientExperienceComp = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="pt-20 w-full bg-blue-950 text-white">
        <div className="container mx-auto px-6 py-3 fontJostRegular">
          <div className="flex flex-wrap">
            <div className="w-full lg:w-7/12 md:w-7/12">
              <Slide left>
                <h2 className="text-3xl lg:text-5xl  font-bold leading-tight fontJostBold">
                  Client Experience
                </h2>
                <p className="mt-12 text-lg">
                  Clients of Clearwater Communications benefit from dedicated
                  account managers who provide personalized service. The
                  company's commitment to client satisfaction is evident through
                  their proactive communication, regular updates, and a
                  willingness to adapt strategies based on performance analytics
                  and client feedback
                </p>

                {/* <p className="mt-12">
                  <Link
                    className="btn bg-sky-950 px-8 py-5 text-white font-semibold rounded-3xl shadow-lg mb-4 mr-4"
                    to={"/contact"}
                  >
                    <span>GET STARTED </span>
                  </Link>
                  <Link
                    className="btn bg-white text-blue-950 px-8 py-5 font-semibold rounded-3xl shadow-lg mb-4"
                    to={"/landing/about"}
                  >
                    <span> ABOUT US</span>
                  </Link>
                </p> */}
              </Slide>
            </div>

            <div className="w-full lg:w-5/12 md:w-5/12 flex justify-center">
              <Slide up>
                <img
                  className="max-w-4/5 w-100 pt-8 md:pt-0 rounded-lg"
                  alt="heroImage"
                  src={`${process.env.PUBLIC_URL + "/images/home/client.jpeg"}`}
                />
              </Slide>
            </div>
          </div>
        </div>
      </div>
      {/* End Hero Section */}
    </>
  );
};

export default ClientExperienceComp;
